import Dashboard from '../src/Dashboard/index.tsx';
export default Dashboard;
